/**
 * Appends `key=value` to a URL's query string.
 *
 * Exists for WebSocket handshakes: browsers cannot set headers on a WebSocket
 * upgrade, so state carried by a header on HTTP and SSE has to travel as a
 * query param there.
 *
 * Built on `URL` rather than string concatenation for the two cases a
 * hand-rolled separator gets wrong: a fragment swallows the param
 * (`/path#frag?k=v` never reaches the server), and a repeated key duplicates
 * rather than replaces. The trade-off: the existing query is re-serialised as
 * `application/x-www-form-urlencoded`, so its BYTES may change even though
 * every value still decodes to what it was (`/` -> `%2F`, space -> `+`). A
 * caller that needs the raw query preserved byte-for-byte must not use this.
 *
 * Takes an ABSOLUTE url — `URL` throws on a relative one. An empty, `null` or
 * `undefined` value appends nothing.
 */
export const appendQueryParam = (
  url: string,
  key: string,
  value: string | null | undefined
): string => {
  if (!value) {
    return url;
  }

  const parsed = new URL(url);
  parsed.searchParams.set(key, value);
  return parsed.toString();
};
